/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RespondentDemographic } from '../models';
/**
 * ResponsesApi - axios parameter creator
 * @export
 */
export const ResponsesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the RespondentDemographics for a Response
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        responseControllerGetRespondentDemographics: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling responseControllerGetRespondentDemographics.');
            }
            const localVarPath = `/api/responses/{id}/respondent-demographics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResponsesApi - functional programming interface
 * @export
 */
export const ResponsesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the RespondentDemographics for a Response
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async responseControllerGetRespondentDemographics(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<RespondentDemographic>>>> {
            const localVarAxiosArgs = await ResponsesApiAxiosParamCreator(configuration).responseControllerGetRespondentDemographics(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ResponsesApi - factory interface
 * @export
 */
export const ResponsesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets the RespondentDemographics for a Response
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async responseControllerGetRespondentDemographics(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<RespondentDemographic>>> {
            return ResponsesApiFp(configuration).responseControllerGetRespondentDemographics(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResponsesApi - object-oriented interface
 * @export
 * @class ResponsesApi
 * @extends {BaseAPI}
 */
export class ResponsesApi extends BaseAPI {
    /**
     * 
     * @summary Gets the RespondentDemographics for a Response
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResponsesApi
     */
    public async responseControllerGetRespondentDemographics(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<RespondentDemographic>>> {
        return ResponsesApiFp(this.configuration).responseControllerGetRespondentDemographics(id, options).then((request) => request(this.axios, this.basePath));
    }
}
